module.exports = __webpack_public_path__ + "static/media/shape-triangle.84f08a69.svg";